import { API, axiosInstance } from "lib";

export const getBranch = (data = {}) => {
  return axiosInstance
    .post(API.GET_SINGLE_BRANCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const createBranch = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_BRANCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};
export const updateBranch = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_BRANCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getBranchListData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {

      return error?.response?.data

    });
};

export const deleteBranchData = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_BRANCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const fetchBranchDetailsData = (data = {}) => {
  return axiosInstance
    .post(API.GET_SINGLE_BRANCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const changeBranchStatusData = (data = {}) => {
  return axiosInstance
    .post(API.CHANGE_BRANCH_STATUS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const updateBranchSetting = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_SETTING_BRANCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const updateEwayBillForBranch = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_EWAY_BRANCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const generateEwayTokenForBranch = (data = {}) => {
  return axiosInstance
    .post(API.EWAY_GENERATE_AUTH_TOKEN, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

// ewayapi/generate-auth-token


export const getAllLrFormateApi = (data = {}) => {
  return axiosInstance
    .post(API.GET_ALL_LR_FORMATE, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {

      return error?.response?.data

    });
};

export const addFormatApi = (data = {}) => {
  return axiosInstance
    .post(API.ADD_LR_FORMAT, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};


export const getAllLrFormatebyBranch = (data = {}) => {
  return axiosInstance
    .post(API.GET_LR_FORMAT_BY_BRANCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {

      return error?.response?.data

    });
};

// export const addLRFormateToBranchApi = (data = {}) => {
//   return axiosInstance
//     .post(API.ADD_LR_FORMAT_TO_BRANCH, data)
//     .then((response) => {
//       return response.data;
//     })
//     .catch((err) => {
//       if (err) {
//         console.log(err);
//       }
//       //      throw err;
//     });
// };


export const deleteFormatFromBranch = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_FORMAT_FROM_BRANCH, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {

      return error?.response?.data

    });
};

export const changeDefaultStatusApi = (data = {}) => {
  return axiosInstance
    .post(API.CHANGE_DEFAULT_STATUS, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {

      return error?.response?.data

    });
};

export const getAllCompanyFormateApi = (data = {}) => {
  return axiosInstance
    .get(API.GET_ALL_COMPANY_FORMATE, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {

      return error?.response?.data

    });
};

export const addInvoiceFormatApi = (data = {}) => {
  return axiosInstance
    .post(API.ADD_INVOICE_FORMAT, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getAllInviceFormatByCompany = (data = {}) => {
  return axiosInstance
    .post(API.GET_INVOICE_FORMAT_BY_COMPANY, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {

      return error?.response?.data

    });
};


